import React from "react";
import {Home} from "./home"
import  "./style.css"
export function MyBlog(){
    return(
        <div className="header" >
        <Home/>
        </div>
    )
}